var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-container uk-text-center uk-margin-large-top uk-margin-large-bottom"},[_c('h2',[_vm._v("This page isn't available")]),_c('h3',[_vm._v("The link you followed may be broken, or the page may have been removed.")]),_c('a',{attrs:{"href":"/"}},[_vm._v(" Go back home ")])])
}]

export { render, staticRenderFns }